// extracted by mini-css-extract-plugin
export default {"body":"Dashboard_body__9N2w8"};